import {useField, useFormikContext} from "formik"
import React, {useState, useEffect} from "react"
import {useTranslation} from 'react-i18next';
import {countries, countries_eu} from "@formApp/utils"

export default ({eu = false}) => {
  const {t} = useTranslation();
  const [field, meta, helpers] = useField('nation');
  const {setFieldValue, touched} = useFormikContext();
  const [currentCountries, setCountries] = useState(countries);

  useEffect(() => {
    if (eu) {
      setCountries(countries_eu);
    } else {
      setCountries(countries);
    }
  }, [eu]);

  const handleChange = async(e) => {
    await field.onChange(e);
    if (touched['dial_code']) return;
    const value = e.target.value;
    const found = currentCountries.find(element => element.code === value);
    setFieldValue('dial_code', found.dial_code);
  };

  return (
    <div className={`formGroup${(meta.touched && meta.error) ? ' error' : ''}`}>
      <select {...field} onChange={handleChange} className='formField --select'>
        <option value="" disabled >{t('Nazione')}</option>
        {currentCountries.map(country => (
          <option value={country.code} key={country.code}>{country.name}</option>
        ))}
      </select>
      {meta.touched && meta.error && <div className="errorMessage">{meta.error}</div>}
    </div>
  )
}

